module.exports = __webpack_public_path__ + "img/post-bank-iran.f69c63d5.svg";